import { apiFetch } from './core'

export async function fetchProjects(filters = {}) {
  const params = new URLSearchParams()
  if (filters.customerId) params.set('customer_id', filters.customerId)
  if (filters.status) params.set('status', filters.status)
  if (filters.search) params.set('search', filters.search)

  const url = `/api/projects${params.toString() ? '?' + params : ''}`
  return apiFetch(url)
}

export async function fetchProject(id) {
  return apiFetch(`/api/projects/${id}`)
}

export async function createProject(data) {
  return apiFetch('/api/projects', {
    method: 'POST',
    body: data,
  })
}

export async function updateProject(id, data) {
  return apiFetch(`/api/projects/${id}`, {
    method: 'PATCH',
    body: data,
  })
}

export async function changeProjectStatus(id, status, reason) {
  return apiFetch(`/api/projects/${id}/change-status`, {
    method: 'POST',
    body: { status, reason },
  })
}

export async function deleteProject(id) {
  return apiFetch(`/api/projects/${id}`, { method: 'DELETE' })
}
